import {guard} from 'effector';
import {combine, forward, merge} from 'effector/effector.cjs';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {isOperator$} from '../../../auth';
import {data$ as commonData$, loadProfileCommonDataFx} from '../../../profile/common';

import {
    clearDataCacheFx,
    data$,
    defaultFilters,
    defaultSortings,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    pageNumber$,
    pageSize$,
    period$,
    periodChanged,
    search$,
    searchChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    tableStateCacheChanged,
    tableStateChanged,
} from './index';

pageNumber$.reset(filtersChanged, sortingsChanged, stateReset);
pageSize$.reset(stateReset);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

data$.on(fetchDataFx.doneData, (_, data) => data).reset(Gate.close);

forward({
    from: tableStateCacheChanged,
    to: clearDataCacheFx,
});

guard({
    clock: merge([
        tableStateChanged,
        searchChanged,
        periodChanged,
        loadProfileCommonDataFx.done,
        Gate.open,
    ]),
    source: combine({
        paging: combine({
            pageNumber: pageNumber$,
            pageSize: pageSize$,
        }),
        filters: filters$.map((v) => mapFilters(v)),
        sortings: sortings$.map((v) => mapSortings(v)),
        search: search$,
        period: period$,
        tin: commonData$.map((v) =>
            !isOperator$.getState() && v?.legalIdentity ? v.legalIdentity : '',
        ),
        hasData: commonData$.map(Boolean),
    }),
    filter: (data) => Gate.status.getState() && data.hasData,
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
